import { Component } from "@angular/core";
import {
    EnabledExtensionFilterFactory,
    ExtensionLoader,
    HomeContentExtension,
    HomeHeaderLoginExtension,
    IEnabledExtensionFilter,
} from "@geolib/geoappbase-client";

@Component({
    selector: "home",
    templateUrl: "./home-content.component.html",
    imports: [ExtensionLoader],
})
export class HomeContentComponent {
    private readonly headerLoginExtension: IEnabledExtensionFilter<HomeHeaderLoginExtension<unknown>>;
    private readonly homeContentExtension: IEnabledExtensionFilter<HomeContentExtension<unknown>>;

    public constructor(
        enabledExtensionFilterFactory: EnabledExtensionFilterFactory,
    ) {
        this.headerLoginExtension = enabledExtensionFilterFactory.create(HomeHeaderLoginExtension.EXTENSION_POINT);
        this.homeContentExtension = enabledExtensionFilterFactory.create(HomeContentExtension.EXTENSION_POINT);
    }

    public get headerLoginEnabledExtensions(): Array<HomeHeaderLoginExtension<unknown>> {
        return this.headerLoginExtension.getEnabledExtensions();
    }

    public get homeContentEnabledExtensions(): Array<HomeContentExtension<unknown>> {
        return this.homeContentExtension.getEnabledExtensions();
    }
}
